<template>
    <CCard>    
        <CCardBody>  
            <CRow>
                <div class="col-lg-12 d-flex align-items-center">
                    <label style="margin-right: 10px; font-weight: bold; width: 40px;" >內容:</label>
                    <ejs-dropdownlist width="180px" id='dropdownlist' :dataSource='HeaderData' :fields="fields" v-model="e_header"  @change="Query"></ejs-dropdownlist>
                    <label style="margin-right: 10px;margin-left: 10px; font-weight: bold; width: 40px;">語系:</label>
                    <ejs-dropdownlist width="180px" id='dropdownlist' :dataSource='LanguageData' :fields="fields" v-model="e_languge"  @change="Query"></ejs-dropdownlist>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <ejs-button cssClass='e-primary' @click.native="Upload">儲存</ejs-button>
                </div>
            </CRow>
            <CRow sm="12" lg="12" >
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;"> 
                    <!--<div ref="editor" style="height:400px;"></div>
                    <div style="margin-top: 0px;padding-bottom: 5px;padding-top: 5px; height:100%; width: 100%;">      -->
                    <div class="container">
                    <!-- 左邊編輯器 --> 
                        <div class="editor-wrapper" ref="editorContainer" ></div>                     
                    </div>
                    <!--<quill-editor v-model="htmlContent" :options="editorOption" style="height:500px; margin-bottom: 40px;"></quill-editor>-->
                    
                    <!-- <div  
                        type="text"
                        id="view-container-wiki"
                        readonly
                        v-html="htmlContent"
                        style="height: 100%; overflow-y: auto;">
                    </div>               -->
                    <!--</div> -->
                </CCol>
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;"> 
                    <!--<div ref="editor" style="height:400px;"></div>
                    <div style="margin-top: 0px;padding-bottom: 5px;padding-top: 5px; height:100%; width: 100%;">      -->
                    <div class="container">
              
                        <!-- 右邊即時預覽 -->
                        <div class="preview-wrapper">
                        <iframe :srcdoc="code" style="width: 100%;" frameborder="0"></iframe>
                        </div>
                    </div>
                    <!--<quill-editor v-model="htmlContent" :options="editorOption" style="height:500px; margin-bottom: 40px;"></quill-editor>-->
                    
                    <!-- <div  
                        type="text"
                        id="view-container-wiki"
                        readonly
                        v-html="htmlContent"
                        style="height: 100%; overflow-y: auto;">
                    </div>               -->
                    <!--</div> -->
                </CCol>
                           
            </CRow>
        </CCardBody>
    </CCard>  
</template>
<script>
import Vue from "vue";

import Quill from 'quill'

// 引入樣式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-better-table/dist/quill-better-table.css'

import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/theme/material.css'
import 'codemirror/addon/edit/matchbrackets.js'

// 引入模組
import QuillBetterTable from 'quill-better-table'

// 註冊 module
Quill.register(
  {
    'modules/better-table': QuillBetterTable
  },
  true
)


import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';
import { ButtonComponent } from '@syncfusion/ej2-vue-buttons';
import Loading from 'vue-loading-overlay';

Vue.use(Loading);
let Loader = undefined;
export default Vue.extend({ 
   
    components: {
        "ejs-dropdownlist": DropDownListComponent,
        "ejs-button": ButtonComponent, 
    },
    data: function() {
        return {
            code: `<h1>Hello Vue 2 + CodeMirror!</h1>\n<p>Edit me!</p>`,
            editor: null,
            e_languge:'TW',
            e_header:'System',
            //vue quill
            //DownList
            fields: { text: 'text', value: 'value' },
            HeaderData: [
                { value: 'System', text: '系統公告' },
                { value: 'About', text: '關於我們' },
                { value: 'Question', text: '常見問題' }
            ],
            LanguageData:[
                { value: 'TW', text: '繁體' },
                { value: 'CN', text: '簡體' },
                { value: 'en', text: '英文' },
                { value: 'ja', text: '日文' },
                { value: 'th', text: '泰語' },
            ],
            editorOption: {
                theme: 'snow',
                table: true, // 啟用 Quill 內建 table module
                modules: {
                    toolbar: {
                        container: [
                        ['bold', 'italic', 'underline', 'strike'], // toggled buttons 
                        ['blockquote', 'code-block'], 
                        
                        [{ 'header': 1 }, { 'header': 2 }], // custom button values 
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }], 
                        [{ 'script': 'sub'}, { 'script': 'super' }], // 升冪與降冪
                        [{ 'indent': '-1'}, { 'indent': '+1' }], // 縮排與減少縮排
                        [{ 'direction': 'rtl' }], // text direction 
                        
                        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown 
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
                        
                        [{ 'color': [] }, { 'background': [] }], // dropdown 從 theme 獲取預設值 
                        [{ 'font': [] }], 
                        [{ 'align': [] }], 
                        
                        ['clean'], // 移除格式 
                        ['table'] // <-- 加入表格按鈕

                        ],
                        handlers: {
                            table() {
                                alert('12313');
                                const tableModule = this.quill.getModule('better-table')
                                tableModule.insertTable(3, 3) // 預設插入 3x3 表格
                            }
                        }
                    },                    
                },
                 
            }
        }
    },
    created(){
        this.Query();
    },
    methods: {
        //component
        Query(){
            console.log(`${this.e_header}_${this.e_languge}`);
            this.gethtml();
        },
        Upload(){
            console.log(`${this.e_header}_${this.e_languge}`);
            console.log(`${this.htmlContent}`);
            this.puthtml();
        },
        //api
        gethtml: function () {        
          this.showLoading();            
          this.axios({
            method: 'get',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/AppManager/Msg?id=${this.e_header}_${this.e_languge}`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {            
                this.hideLoading();   
                if (!response.data.ok) { this.$toast.open({message: response.data.msg, type: "error", duration: 5000, dismissible: true }) }
                this.code = response.data.datas
                this.htmlContent=response.data.datas
                this.$refs.editor.quill.clipboard.dangerouslyPasteHTML(this.htmlContent);
            })
            .catch((error) => { this.showError(error, true) }
          )        
        },
        puthtml: function () {        
          this.showLoading();            
          this.axios({
            method: 'put',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/AppManager/Msg`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data:{
                id:`${this.e_header}_${this.e_languge}`,
                html:this.code
            },
          })
          .then((response) => {            
            this.hideLoading();   
            if (!response.data.ok) { this.$toast.open({message: response.data.msg, type: "error", duration: 5000, dismissible: true }) }
               this.gethtml();
            })
            .catch((error) => { this.showError(error, true) }
          )        
        },
        showLoading() {
            Loader = this.$loading.show({
                    container: this.$refs.loadingContainer,
                    canCancel: true, // default false
                    onCancel: this.yourCallbackMethod,
                    color: 'green',
                    loader: 'dots',  // spinner, dots, bars
                    width: 164,
                    height: 164,
                    backgroundColor: 'black',
                    opacity: 0.5,
                    zIndex: 999,
                });
        },
        hideLoading() {
            Loader.hide();
        }
    },
    watch: {
    // 如果 data 改變，也同步更新編輯器（完全雙向）
        code(val) {
            if (this.editor && this.editor.getValue() !== val) {
                this.editor.setValue(val);
            }
        },
    },
    mounted() {
        // 初始化 CodeMirror
        this.editor = CodeMirror(this.$refs.editorContainer, {
            value: this.code,
            mode: 'htmlmixed',
            theme: 'material',
            lineNumbers: true,
            matchBrackets: true,
            tabSize: 2,
            lineWrapping: true,
        })

        // 當內容改變時更新右邊 preview
        this.editor.on('change', () => {
            this.code = this.editor.getValue()
        })
    }

})
</script>
<style>
 #textareaWrapper .e-multi-line-input {
    max-width: 100%;
 }
 /* 左邊編輯器 */
.editor-wrapper {
  height: 100%;
}

/* 右邊即時預覽 */
.preview-wrapper {
  height: 100%;
}

.preview-wrapper iframe {
  width: 100%;
  height: 700px;
  border-left: 1px solid #ccc;
}
.CodeMirror {
    height: 700px;
}
</style>